import React from 'react'
import Moment from 'react-moment'
import { pascalCase } from 'change-case'
import * as v from 'variables/styles'

import { StatusTag, DivText } from 'components'
import { getOptionTitle, numberFormat } from 'core/utilities'

export const typeOfBondOptions = [
  {
    key:1,
    value:'advancePayment',
    text:'Advance Payment'
  },
  {
    key:2,
    value:'performance',
    text:'Performance'
  },
  {
    key:3,
    value:'contract',
    text:'Contract'
  },
  {
    key:4,
    value:'product',
    text:'Product'
  },
  {
    key:5,
    value:'retention',
    text:'Retention'
  },
  {
    key:6,
    value:'facilityElectricityFleetCard',
    text:'Facility(Electricity/Fleet Card)'
  },
  {
    key:7,
    value:'other',
    text:'Other'
  },
]

export const referenceDocumentOptions = [
  { 
    key:1,
    value: 'contract', 
    text: 'Contract' 
  },
  { 
    key:2,
    value: 'poNumber', 
    text: 'Purchase Order Number' 
  }
]

export const requestTypeOptions = [
  { 
    key:1,
    value: 'new', 
    text: 'New' 
  },
  { 
    key:2,
    value: 'extend', 
    text: 'Extend' 
  }
]

export const referenceOriginalOptions = [
  { 
    key:1,
    value: true, 
    text: 'Original' 
  },
  { 
    key:2,
    value: false, 
    text: 'Change Reference Doc.' 
  }
]

export const requestForTypeOptions = [
  { 
    key:1,
    value: 'customer', 
    text: 'Customer' 
  },
  { 
    key:2,
    value: 'vendor', 
    text: 'Vendor' 
  }
]

export const search_statusOption = [
  { key: 0,value: '-', text: 'All Status' },
  {
    key:1,
    value:0,
    text:'Draft'
  },
  {
    key:2,
    value:200,
    text:'Approver Review'
  }, 
  {
    key:3,
    value:201,
    text:'Finance Review'
  },
  {
    key:4,
    value:202,
    text:'Finance Processing'
  },
  {
    key:5,
    value:203,
    text:'Wait To Receive'
  },
  {
    key:6,
    value:500,
    text:'Reject'
  },
  {
    key:6,
    value:900,
    text:'Complete'
  },
]

export const statusColor = {
  0: v.tagDraft,
  200: v.tagInProgress,
  201: v.tagInProgress,
  202: v.tagNew,
  203: v.tagNew,
  500: v.tagReject,
  800: v.tagCanceled,
  900: v.tagCompleted
}

export const buttonColor = {
  Approve:'green',
  Accept:'green',
  Submit:'green',
  SaveSubmit:'green',
  Resubmit:'green',
  Revise:'orange',
  Reject:'red',
  Cancel:'red',
}

export const columnBgCompanyRequest = () => {
  return [
    {
      Header: 'Status',
      accessor: 'status',
      width: 135,
      Cell: row => (<DivText><StatusTag status={row.value} statusName={row.original.statusName} style={{background:statusColor[`${row.value}`]}}/></DivText>)
    }, 
    {
      Header: 'Doc No.',
      accessor: 'documentNumber',
      width: 100,
      Cell: row => (<DivText>{row.value}</DivText>)
    }, 
    {
      Header: 'Document Type',
      accessor: 'documentType',
      width: 80,
      Cell: row => (<DivText>{pascalCase(row.value)}</DivText>)
    }, 
    {
      Header: () => (<DivText left>Title</DivText>),
      accessor: 'title',
    }, 
    {
      Header: 'Company',
      accessor: 'companyName',
      width: 100,
    }, 
    {
      Header: 'Vendor/Customer',
      accessor: 'vendorCode',
      width: 120,
    }, 
    {
      Header: 'Amount',
      accessor: 'amount',
      width: 100,
      style: { display: 'flex', justifyContent: 'flex-end' },
      Cell: row => numberFormat(row.value)
    }, 
    {
      Header: 'Due date',
      accessor: 'dueDate',
      width: 120,
      Cell: row => (row.value && <DivText><Moment format='DD MMM YYYY'>{row.value}</Moment></DivText>)
    }, 
    {
      Header: 'Created date',
      accessor: 'createdDate',
      width: 120,
      Cell: row => (row.value &&
        <DivText>
          {row.value ? <Moment format='DD MMM YYYY HH:mm'>{row.value}</Moment> : '-'}
        </DivText>)
    },
    {
      Header: 'Modify Date',
      accessor: 'modifiedDate',
      width: 120,
      Cell: row => (row.value &&
        <DivText>
          {row.value ? <Moment format='DD MMM YYYY HH:mm'>{row.value}</Moment> : '-'}
        </DivText>)
    }
  ]
}